var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("About "+_vm._s(_vm.entity.name || _vm.entity.full_name))]),_c('wysiwyg-editor',{staticClass:"mt-5",attrs:{"value":_vm.entity.notes,"height":500},on:{"update:value":function($event){return _vm.$set(_vm.entity, "notes", $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }